export const THEME_MODES = [
    "light",
    "dark",
    "midnight",
    "high-contrast",
    "system",
];
export const DENSITIES = ["compact", "cozy", "comfortable"];
export const RADII = ["sharp", "soft", "round"];
export const DEFAULT_PREFERENCES = {
    mode: "system",
    density: "cozy",
    radius: "soft",
};
export const THEME_STORAGE_KEY = "pikbase.theme";
export const LEGACY_THEME_STORAGE_KEY = "gsb.theme";
export const LEGACY_SCALAR_THEME_STORAGE_KEY = "apexbase-ui-theme";
function isOneOf(list, value) {
    return (typeof value === "string" && list.includes(value));
}
export function parsePreferences(raw) {
    const parsed = parseStructuredPreferences(raw);
    return parsed === null
        ? DEFAULT_PREFERENCES
        : { ...DEFAULT_PREFERENCES, ...parsed };
}
function parseStructuredPreferences(raw) {
    if (raw === null)
        return null;
    try {
        const parsed = JSON.parse(raw);
        if (typeof parsed !== "object" || parsed === null)
            return null;
        const record = parsed;
        const preferences = {};
        if (isOneOf(THEME_MODES, record.mode))
            preferences.mode = record.mode;
        if (isOneOf(DENSITIES, record.density))
            preferences.density = record.density;
        if (isOneOf(RADII, record.radius))
            preferences.radius = record.radius;
        return Object.keys(preferences).length > 0 ? preferences : null;
    }
    catch {
        return null;
    }
}
export function readStoredPreferences(storage, fallback = DEFAULT_PREFERENCES) {
    for (const key of [THEME_STORAGE_KEY, LEGACY_THEME_STORAGE_KEY]) {
        const parsed = parseStructuredPreferences(storage.getItem(key));
        if (parsed !== null)
            return { ...fallback, ...parsed };
    }
    const scalar = storage.getItem(LEGACY_SCALAR_THEME_STORAGE_KEY);
    return isOneOf(THEME_MODES, scalar)
        ? { ...fallback, mode: scalar }
        : fallback;
}
export function writeStoredPreferences(storage, preferences) {
    storage.setItem?.(THEME_STORAGE_KEY, JSON.stringify(preferences));
}
//# sourceMappingURL=preferences.js.map